// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_3Zmbi","footerFullWidth":"index_footerFullWidth_3FpfO","inner":"index_inner_2wSN7","logo":"index_logo_39TFw"};